import recentAddToCart from './recent-add-to-cart';

export default recentAddToCart;
